const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class ImpactOfHarmony extends Event {
    constructor(){
        super(
            Age.Age3,
            EventNames.ImpactOfHarmony,
            "Each civilization scores 4 culture for each farm and mine, or for each urban building, or for each military unit, whichever is the lowest.",
            {}
        )
    }
}

module.exports = ImpactOfHarmony;